import { memo } from 'react'

import { Button, Text } from '@cash-me/react-components'

import { Col, Grid } from 'components/grid'

import { homeRenovationWorthItItems } from './data'
import * as S from './styles'

type Props = {
  onClick: () => void
}

export const HomeRenovationWorthIt = memo(({ onClick }: Props) => (
  <S.Section aria-labelledby="home-renovation-worth-it-title">
    <Grid col={{ phone: 1, tablet: 12 }}>
      <Col col={{ tablet: 12, desktop: 10 }} start={{ desktop: 2 }}>
        <S.Header>
          <Text
            id="home-renovation-worth-it-title"
            as="h2"
            size="heading2"
            weight="medium"
            color="var(--colors-neutral-text-default)"
          >
            Vale a pena fazer um <S.Highlight>Empréstimo para Reforma?</S.Highlight>
          </Text>

          <S.Introduction>
            <Text as="p" size="body1" weight="medium" color="var(--colors-blue-text-default)">
              Sim, o Crédito para Reforma de Casa gera mais qualidade de vida, valorização patrimonial e ajuda você a
              realizar um projeto importante sem precisar esperar anos.
            </Text>
            <Text as="p" size="body1" color="var(--colors-neutral-text-default)">
              Muitas pessoas passam anos adiando melhorias por não terem todo o valor disponível de uma só vez. Com
              acesso ao crédito adequado, você pode fazer a reforma no momento certo e distribuir esse investimento ao
              longo do tempo.
            </Text>
          </S.Introduction>
        </S.Header>

        <S.CardList>
          {homeRenovationWorthItItems.map(({ id, icon, title, description }) => (
            <S.Card key={id}>
              <S.IconWrapper aria-hidden>{icon}</S.IconWrapper>
              <Text as="h3" size="heading5" weight="medium" color="var(--colors-neutral-text-contrast-default)">
                {title}
              </Text>
              <Text as="p" size="body1" color="var(--colors-neutral-text-contrast-default)">
                {description}
              </Text>
            </S.Card>
          ))}
        </S.CardList>

        <S.Cta>
          <Button
            aria-label="Simular empréstimo para reforma de casa agora"
            size="lg"
            type="button"
            variants="text-only"
            onClick={onClick}
          >
            Simular agora
          </Button>
        </S.Cta>
      </Col>
    </Grid>
  </S.Section>
))

HomeRenovationWorthIt.displayName = 'HomeRenovationWorthIt'
